import { CALL_API, HTTP_METHODS } from '../../../../../setup/constants'
import * as ACTIONS from '../constants'


export const clearStore = () =>
({
  type: ACTIONS.CLEAR_USER_STORE
})


export const flashMessages = () =>
({
  type: ACTIONS.FLASH_MESSAGES
})


export const searchForUsers = (params) =>
({
  type: CALL_API,
  meta: {
    actions: {
      init: ACTIONS.SEARCH_USERS_INIT,
      success: ACTIONS.SEARCH_USERS_SUCCEDED,
      fail: ACTIONS.SEARCH_USERS_FAILED
    },
    endpoint: ACTIONS.ENDPOINT_SEARCH_USERS,
    method: HTTP_METHODS.GET,
    params,
    auth: true
  }
})


export const downloadUsers = (params) =>
({
  type: CALL_API,
  meta: {
    actions: {
      init: ACTIONS.DOWNLOAD_USERS_INIT,
      success: ACTIONS.DOWNLOAD_USERS_SUCCEDED,
      fail: ACTIONS.DOWNLOAD_USERS_FAILED
    },
    endpoint: ACTIONS.ENDPOINT_DOWNLOAD_USERS,
    method: HTTP_METHODS.GET,
    extra: {
      responseType: 'blob',
    },
    headers: {
      "Content-Disposition": "attachment; filename=users.xlsx",
    },
    params,
    auth: true
  }
})


export const deleteUser = (param) =>
({
  type: CALL_API,
  meta: {
    actions: {
      init: ACTIONS.DELETE_USER_INIT,
      success: ACTIONS.DELETE_USER_SUCCEDED,
      fail: ACTIONS.DELETE_USER_FAILED
    },
    endpoint: ACTIONS.ENDPOINT_USER.replace(':param', param),
    method: HTTP_METHODS.DELETE,
    auth: true
  }
})


export const fetchUsers = (params) =>
({
  type: CALL_API,
  meta: {
    actions: {
      init: ACTIONS.FETCH_USERS_INIT,
      success: ACTIONS.FETCH_USERS_SUCCEDED,
      fail: ACTIONS.FETCH_USERS_FAILED
    },
    endpoint: ACTIONS.ENDPOINT_USERS,
    method: HTTP_METHODS.GET,
    params,
    auth: true
  }
})


export const fetchUser = (param) =>
({
  type: CALL_API,
  meta: {
    actions: {
      init: ACTIONS.FETCH_USER_INIT,
      success: ACTIONS.FETCH_USER_SUCCEDED,
      fail: ACTIONS.FETCH_USER_FAILED
    },
    endpoint: ACTIONS.ENDPOINT_USER.replace(':param', param),
    method: HTTP_METHODS.GET,
    auth: true
  }
})


export const updateUser = (param, payload) =>
({
  type: CALL_API,
  payload,
  meta: {
    actions: {
      init: ACTIONS.EDIT_USER_INIT,
      success: ACTIONS.EDIT_USER_SUCCEDED,
      fail: ACTIONS.EDIT_USER_FAILED
    },
    endpoint: ACTIONS.ENDPOINT_USER.replace(':param', param),
    method: HTTP_METHODS.PUT,
    auth: true
  }
})


export const subscribeUser = (param, payload) =>
({
  type: CALL_API,
  payload,
  meta: {
    actions: {
      init: ACTIONS.SET_USER_SUBSCRIPTION_INIT,
      success: ACTIONS.SET_USER_SUBSCRIPTION_SUCCEDED,
      fail: ACTIONS.SET_USER_SUBSCRIPTION_FAILED
    },
    endpoint: ACTIONS.ENDPOINT_SUBESCRIBE.replace(':param', param),
    method: HTTP_METHODS.PUT,
    payload,
    auth: true
  }
})


export const createUser = (payload) =>
({
  type: CALL_API,
  payload,
  meta: {
    actions: {
      init: ACTIONS.CREATE_USER_INIT,
      success: ACTIONS.CREATE_USER_SUCCEDED,
      fail: ACTIONS.CREATE_USER_FAILED
    },
    endpoint: ACTIONS.ENDPOINT_USERS,
    method: HTTP_METHODS.POST,
    auth: true
  }
})


export const fetchAppointments = ({ id, page }) =>
({
  type: CALL_API,
  meta: {
    actions: {
      init: ACTIONS.FETCH_USER_APPOINTMENTS_INIT,
      success: ACTIONS.FETCH_USER_APPOINTMENTS_SUCCEDED,
      fail: ACTIONS.FETCH_USER_APPOINTMENTS_FAILED
    },
    endpoint: `${ACTIONS.ENDPOINT_USER_APPOINTMENTS.replace(':param', id)}?page=${page}`,
    method: HTTP_METHODS.GET,
    auth: true
  }
})


export const editAppointments = (param, payload) =>
({
  type: CALL_API,
  payload,
  meta: {
    actions: {
      init: ACTIONS.EDIT_USER_APPOINTMENTS_INIT,
      success: ACTIONS.EDIT_USER_APPOINTMENTS_SUCCEDED,
      fail: ACTIONS.EDIT_USER_APPOINTMENTS_FAILED
    },
    endpoint: ACTIONS.ENDPOINT_APPOINTMENTS,
    method: HTTP_METHODS.PUT,
    auth: true
  }
})


export const fetchUserActivities = (params, payload) =>
({
  type: CALL_API,
  payload,
  meta: {
    actions: {
      init: ACTIONS.FETCH_ACTIVITIES_INIT,
      success: ACTIONS.FETCH_ACTIVITIES_SUCCEDED,
      fail: ACTIONS.FETCH_ACTIVITIES_FAILED
    },
    endpoint: ACTIONS.ENDPOINT_FETCH_ACTIVITIES.replace(':id', payload.id),
    method: HTTP_METHODS.GET,
    params,
    auth: true
  }
})

export const resetUsersFiltersBar = (payload) => ({
  type: ACTIONS.RESET_USERS_FILTERS,
  payload
})